import FieldConfig from "../../../proto/field-config"
import FieldProto from "../../../proto/field-proto"
import {Duration} from "moment/moment"
import FieldAge_TableCell from "./render/table/table-cell"

const debug = false
// const debug = "FieldAge"

export default class FieldAge extends FieldProto {

    constructor(config:FieldConfig) {
        super(config)

        this.icon               = 'i5-lead-time'

        this.typeLabel          = "Age"
        this.typeDescription    = "Age field"

        this.label              = _.get(config, 'label', this.typeLabel)

        this.renderComponents.tableCell     = FieldAge_TableCell
    }

    getViewValue(model: any): any {
        const duration: Duration = _.get(model, this.fieldId, null)

        debug && console.log(debug, 'getViewValue', duration, this.fieldId, model)

        return duration ? gd.utils.momentIntervalHumanize(duration) : '' //duration?.humanize()
    }

    sortValue(value: any, model?: any) {
        const duration: Duration = _.get(model, this.fieldId, null)
        return duration ? duration.as('seconds') : 0
    }
}
